// Import the functions you need from the SDKs you need

import { initializeApp } from "firebase/app";

// import { getAnalytics } from "firebase/analytics";

// TODO: Add SDKs for Firebase products that you want to use

// https://firebase.google.com/docs/web/setup#available-libraries


// Your web app's Firebase configuration

// For Firebase JS SDK v7.20.0 and later, measurementId is optional

const firebaseConfig = {

  apiKey: "AIzaSyB_9InmuO15OhFMR4MBv89M-EWg5yS1MwA",

  authDomain: "taipei-rioter.firebaseapp.com",

  databaseURL: "https://taipei-rioter-default-rtdb.firebaseio.com",

  projectId: "taipei-rioter",

  storageBucket: "taipei-rioter.appspot.com",

  messagingSenderId: "1070259136150",

  appId: "1:1070259136150:web:dbca6dd8f27886f9b004b7",

  measurementId: "G-JYRW2G2DBX"

};


// Initialize Firebase

const app = initializeApp(firebaseConfig);

// const analytics = getAnalytics(app);

